<template>
  <div class="pointer data-table-th-line" :class="[sort_key == column ? 'data-table-sort-active' : '', 'data-table-list-'+css]" @click="sortBy(column)" :id="'item_'+column">
    <span class="data-table-underline"><pre class="list-column">{{title}}</pre></span>
    <font-awesome-icon
      v-if="sort_key == column"
      :icon="['fas', sort_key == column && sort_order == 'asc' ? 'arrow-up' : sort_key == column && sort_order == 'desc' ? 'arrow-down' : '']"
      style="margin-left:3px;"
    />
  </div>
</template>

<script>
export default {
  name: "listColumn",
  props: ["column", "title", "css", "sort_key", "sort_order"],
  data() {
    return {
    };
  },
  computed: {
  },
  created() {},
  mounted() {},
  methods: {
    sortBy(column){
      this.$emit("sortBy", column)
    }
  },
};
</script>